<template>
  <header
    class="from-gp-midnight-3-a to-gp-midnight-3-b z-14 bg-linear-to-r fixed inset-x-0 top-0 flex items-center justify-between gap-8 p-5 xl:hidden"
    :class="{ 'shadow-[0_0_35px_0_rgba(0,0,0,0.3)]': !headerIsScrolled }"
  >
    <div>
      <a class="text-gp-rhino cursor-pointer" data-testid="mobile-nav-toggle" @click="showMobileNav">
        <font-awesome-icon :icon="faBars" />
      </a>
    </div>
    <div class="md:flex-1">
      <div class="w-[160px]">
        <a :href="homeUrl">
          <img src="https://cdn.g-portal.com/images/brand/logo-xl.svg" alt="g-portal-logo" />
        </a>
      </div>
    </div>
    <div class="shrink-0">
      <a class="cursor-pointer" :href="profileUrl" target="_blank">
        <profile-icon class="size-8 rounded-full"></profile-icon>
      </a>
    </div>
  </header>
</template>

<script setup lang="ts">
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useClientStore } from "../store/client";
import { useWiUtils } from "../util/webinterface";
import ProfileIcon from "./ProfileIcon.vue";
import useHeaderScrolled from "./header/scrolled";

const client = useClientStore();

function showMobileNav() {
  client.setMobileNav(true);
}

const headerIsScrolled = useHeaderScrolled();

const { homeUrl, profileUrl } = useWiUtils();
</script>
